import React, { Component } from 'react';
import tr from '../../../libs/tr'
import Cleave from 'cleave.js/react';
import './CardPnl.css';
import crdsciempty from '../../../images/public/userarea/crdsciempty.png';
import crdscia from '../../../images/public/userarea/crdscia.png';
import crdscis from '../../../images/public/userarea/crdscis.png';
import crdscij from '../../../images/public/userarea/crdscij.png';
import crdscib from '../../../images/public/userarea/crdscib.png';
import crdpagana from '../../../images/public/userarea/crdpagana.png';
import crdpaganj from '../../../images/public/userarea/crdpaganj.png';
import crdpaganb from '../../../images/public/userarea/crdpaganb.png';
//import crdsciblock from '../../../images/public/userarea/crdsciblock.png';
import alerts from '../../../images/public/userarea/alerts.png';
import assistel from '../../../images/public/userarea/assistel.png';
import { validateCard, activateCard } from '../../../libs/fetch'
//import WaitLoad from "../../../assets/components/loading/WaitLoad";
import ReactLoading from 'react-loading';
import Cookies from 'universal-cookie';
let cookies = new Cookies;

class CardPnl extends Component {

    constructor(props) {
        super(props);

        this.cardType = 0; // decide the format number of cards by type

        this.state = {
            isLoading: false,

            Adult: false, // True when the skier is Adult
            Senior: false, // True when the skier is Senior
            Junior: false, // True when the skier is Junior
            Baby: false, // True when the skier is Baby


            Block: props.Block,
            // Activate: false,
            // Active: true,
            Activate: props.Activate,
            Active: props.Active,
            Expired: props.Expired,
            Paganella: props.Paganella,
            /* TODO placeholders, to replace in i18n file */
            code: "30161472562509881850366",
            Telnumber: "+39 011 19 116 039",

            activeSkier: null,

            // loaded data check
            loadedData: false,

            cardImage: null,

            cardType: "test",
            borderBottomColor: 'rgba(255, 255, 255, 0.7)',//'rgba(255, 0, 0, 0.7)'
            isCardFormatValid: false,
            canAcceptEntry: true,//to disable card insertion when api is in progress
            cardStr: null,
            cardIndex: props.cardIndex,//is used to understand which card has been clicked

        };

        console.log(props);

        this.cardPnlOnclick = this.cardPnlOnclick.bind(this);

    }

    componentDidMount() {
        this.setState({ activeSkier: this.props.activeSkier });

        this.checkCardType() // check card type
        // loadedData
        this.setState({ loadedData: true, code: this.props.activeSkier.code });
    }

    cardPnlOnclick(info, params) {
        localStorage.setItem('cardIndex', JSON.stringify(this.props.cardIndex));
        this.props.callback(info, params);
    }

    // return card type state for UI
    checkCardType = () => {
        let cardType = this.props.activeSkier.type.toLowerCase();
        let provider = this.props.activeSkier.provider.toLowerCase();

        console.log("CARD INFO: ", this.props.activeSkier);
        console.log("CARD INFO: ", cardType, provider);

        if (provider === "skidata") {
            this.setState({ provider: 0 });
            console.log("CARD INFO: provider == skidata");
            // this.state.cardImage = cardType.toLowerCase() == "baby" ? crdscib : cardType.toLowerCase() == "junior" ? crdscij : cardType.toLowerCase() == "senior" ? crdscis : crdscia
            switch (cardType.toLowerCase()) {
                case "baby":
                    this.setState({ cardType: tr.t("Baby"), cardImage: crdscib });
                    break;
                case "junior":
                    this.setState({ cardType: tr.t("Junior"), cardImage: crdscij });
                    break;
                case "senior":
                    this.setState({ cardType: tr.t("Senior"), cardImage: crdscis });
                    break;
                default:
                    this.setState({ cardType: tr.t("Adulto"), cardImage: crdscia });
                    break;
            }
        } else {
            console.log("CARD INFO: provider == Axess");
            this.setState({ provider: 1 });

            // this.state.cardImage = cardType.toLowerCase() == "baby" ? crdpaganb : cardType.toLowerCase() == "junior" ? crdpaganj : crdpagana
            switch (cardType.toLowerCase()) {
                case "baby":
                    this.setState({ cardType: tr.t("Baby"), cardImage: crdpaganb });
                    break;
                case "junior":
                    this.setState({ cardType: tr.t("Junior"), cardImage: crdpaganj });
                    break;
                // case "senior":
                //     this.setState({ cardType: tr.t("Senior"), cardImage: crdscis });
                //     break;
                default:
                    this.setState({ cardType: tr.t("Adulto"), cardImage: crdpagana });
                    break;
            }
        }
    }



    validateCard = (cardStr) => {
        let access_token = cookies.get('access_token');
        let params = { card_code: cardStr }
        validateCard(this, access_token, params)
            .then((response) => {
                console.log("[CardPnl] validateCard @response: ", response);
                this.setState({ canAcceptEntry: true });
                if (response.status == "success") {
                    //Card can be assigned to the user.
                    this.setState({
                        cardStr: cardStr,
                        borderBottomColor: 'rgba(255, 255, 255, 0.7)',
                        isCardFormatValid: true,
                    });
                    return
                } else {
                    this.setState({
                        borderBottomColor: 'rgba(255, 0, 0, 0.7)',
                        isCardFormatValid: false,
                    });
                    console.log("this.cardPnlOnclick('cardValidationError');", response.message);
                    this.cardPnlOnclick('cardValidationError', response.message);
                    //Card cannot be assigned to the user.
                }
            });
        return
    }

    onSkidataCardNumberChange = (event) => {
        let rawVal = event.target.rawValue;
        let formattedVal = event.target.value;
        if (rawVal.length > 22) {
            this.setState({ canAcceptEntry: false });
            console.log(formattedVal);
            let cardStr = formattedVal.replace(/\s/g, '');//removing spaces for restcall
            console.log(cardStr);
            this.validateCard(cardStr);
        } else {
            this.setState({
                borderBottomColor: 'rgba(255, 255, 255, 0.7)',
                isCardFormatValid: false,
            });
        }

    }

    onAxessCardNumberChange = (event) => {
        let rawVal = event.target.rawValue;
        let formattedVal = event.target.value;
        if (rawVal.length > 13) {
            this.setState({ canAcceptEntry: false });
            console.log(formattedVal);
            let cardStr = formattedVal.replace(/\s/g, '');//removing spaces for restcall
            console.log(cardStr);
            this.validateCard(cardStr);
        } else {
            this.setState({
                borderBottomColor: 'rgba(255, 255, 255, 0.7)',
                isCardFormatValid: false,
            });
        }

    }


    activateCard = () => {
        this.setState({ isLoading: true });
        let access_token = cookies.get('access_token');
        let params = {
            card_code: this.state.cardStr,
            card_id: this.state.activeSkier.card_id,
            date_of_birth: this.state.activeSkier.birthday
        }
        console.log(params);

        activateCard(this, access_token, this.state.activeSkier.card_id,this.state.cardStr )
            .then((response) => {
                console.log("[CardPnl] activateCard @response: ", response);
                this.setState({ canAcceptEntry: true });
                if (response.status === "success") {
                    //Card can be assigned to the user.
                    this.setState({ activeSkier: { ...this.state.activeSkier, code: this.state.cardStr } });
                    this.setState({
                        Activate: false,
                        Active: true,
                        borderBottomColor: 'rgba(255, 255, 255, 0.7)',
                        isCardFormatValid: true,
                    });
                    return
                } else {
                    this.setState({
                        borderBottomColor: 'rgba(255, 0, 0, 0.7)',
                        isCardFormatValid: false,
                    });
                    this.cardPnlOnclick('cardValidationError', response.message);

                    //Card cannot be assigned to the user.
                }
            });
        return
    }

    render() {
        return (
            <div className="cardPnl">
                {this.state.loadedData && <div>

                    {/* ACTIVATE #notes: When user says I already have a card. The provider is known here */}
                    {this.state.Activate &&
                        <div>
                            <div className="cardType mb-4">
                                <img src={crdsciempty} className="img-fluid sn_shadow" />
                            </div>
                            <div className="disPnl">
                                <div className="lineD d-flex align-items-center">
                                    {tr.t("Cardactivate")}
                                    <div className="alertsD ml-3">
                                        <img src={alerts} className="img-fluid" />
                                    </div>
                                </div>
                                <div className="lineI mb-3">

                                    {/* <input type="text" name="number" placeholder={tr.t("Insert")} className="txtStyleID" maxLength="50" /> */}
                                    {this.state.provider === 0 && <Cleave
                                        className={this.state.isCardFormatValid ? "txtStyleID_ticked" : "txtStyleID"}
                                        style={{ borderBottomColor: this.state.borderBottomColor, borderBottomWidth: 2 }}
                                        options={{
                                            delimiters: ['-', ' ', ' ', ' ', ' ', '-'],
                                            blocks: [2, 4, 4, 4, 4, 4, 1],
                                            uppercase: true
                                        }}
                                        onChange={this.onSkidataCardNumberChange}
                                        disabled={!this.state.canAcceptEntry}
                                        placeholder={tr.t("NumberCard") + " (No Paganella)"}
                                    />}
                                    {this.state.provider === 1 && <Cleave
                                        className={this.state.isCardFormatValid ? "txtStyleID_ticked" : "txtStyleID"}
                                        style={{ borderBottomColor: this.state.borderBottomColor, borderBottomWidth: 2 }}
                                        options={{
                                            delimiters: ['-', '-'],
                                            blocks: [8, 3, 3],
                                            uppercase: true
                                        }}
                                        onChange={this.onAxessCardNumberChange}
                                        disabled={!this.state.canAcceptEntry}
                                        placeholder={tr.t("Insert") + " (Paganella)"}
                                    />}
                                    {this.state.isLoading && <ReactLoading className="loading-cardpnl" type={'spin'} delay={15} width={20} />}
                                </div>
                                <button disabled={!this.state.isCardFormatValid} className="sn_btn sn_minibutton" onClick={this.activateCard}>{tr.t("Activatecard")}</button>
                            </div>
                        </div>
                    }
                    {/*After ACTIVATE #notes: card images are changed*/}
                    {this.state.Active &&
                        <div>
                            <div>
                                <div className="cardType mb-5">
                                    <img src={this.state.cardImage} className="img-fluid sn_shadow" />
                                </div>
                                <div className="actPnl">
                                  <div className="row mb-3">
                                    <div className="col-auto titlePnlc">
                                      <div className="lineCIT1">{tr.t("Number")}</div>
                                    </div>
                                    <div className="col insertedPnlc">
                                      <div className="lineCI1">
                                        {this.state.activeSkier.code}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-4">
                                    <div className="col-auto titlePnlc">
                                      <div className="lineCIT2">{tr.t("Type")}</div>
                                    </div>
                                    <div className="col insertedPnlc">
                                      <div className="lineCI2">
                                        {this.state.cardType}
                                      </div>
                                    </div>
                                  </div>

                                  <button className="sbtn3" onClick={() => this.cardPnlOnclick("blockButton")}>{tr.t("Blockcard")}</button>
                                </div>
                            </div>
                        </div>
                    }
                    {/* Block */}

                    
                    
                    {this.props.Block ?
                      <div>
                        <div className="blockPnl">
                          <div className="cardTypeb mb-5">
                            <img src={this.state.cardImage} className="img-fluid grayScale sn_shadow" />
                          </div>
                          <div className="blkPnl">
                            <div className="lineD d-flex align-items-center mb-3">
                              {tr.t("Cardblocked")}
                              <div className="alertsD ml-3">
                                <img src={alerts} className="img-fluid" />
                              </div>
                            </div>
                            <div className="lineR mb-2">{tr.t("Unblockcard")}</div>
                            <div className="lineH d-flex align-items-center mb-4">
                              <div className="telB mr-2">
                                <img src={assistel} className="img-fluid" />
                              </div>
                              {tr.t("Telnumber")}
                            </div>

                            <div className="actPnlb">
                              <div className="row mb-3">
                                <div className="col-auto titlePnlc">
                                  <div className="lineCIT1">{tr.t("Number")}</div>
                                </div>
                                <div className="col insertedPnlc">
                                  <div className="lineCI1">
                                    {this.state.activeSkier.code}
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-4">
                                <div className="col-auto titlePnlc">
                                  <div className="lineCIT2">{tr.t("Type")}</div>
                                </div>
                                <div className="col insertedPnlc">
                                  <div className="lineCI2">
                                    {this.state.cardType}
                                  </div>
                                </div>
                              </div>
                            </div>

                                  
                            {/* The following items are hidden at this moment according to Veronica & Serena */}
                            {/* <button className="sbtn4" onClick={() => this.cardPnlOnclick("replaceCard")}>{tr.t("Replacecard")}</button> */}
                            {/* <div className="lineC" >{tr.t("Cost")}</div> */}
                          </div>
                        </div>
                      </div> : null

                        // <div>
                        //     <div className="blockPnl">
                        //         <div className="cardTypeb">
                        //             <img src={this.state.cardImage} className="responsiveCardb grayScale" />
                        //         </div>
                        //         <div className="blkPnl">
                        //             <div className="lineD d-flex align-items-center">
                        //                 {tr.t("Cardblocked")}
                        //                 <div className="alertsD">
                        //                     <img src={alerts} className="img-fluid" />
                        //                 </div>
                        //             </div>
                        //             <div className="lineR">{tr.t("Unblockcard")}</div>
                        //             <div className="lineH">
                        //                 <div className="telB">
                        //                     <img src={assistel} className="img-fluid" />
                        //                 </div>
                        //                 {tr.t("Telnumber")}
                        //             </div>
                        //             <div className="actPnlb">
                        //                 <div className="titlePnlc">
                        //                     <div className="lineCIT1">{tr.t("Number")}</div>
                        //                     <div className="lineCIT2">{tr.t("Type")}</div>
                        //                 </div>
                        //                 <div className="insertedPnlc">
                        //                     <div className="lineCI1">
                        //                         {this.state.activeSkier.code}
                        //                     </div>
                        //                     <div className="lineCI2">
                        //                         {this.state.cardType}
                        //                     </div>
                        //                 </div>
                        //             </div>
                        //             {/* The following items are hidden at this moment according to Veronica & Serena */}
                        //             {/* <button className="sbtn4" onClick={() => this.cardPnlOnclick("replaceCard")}>{tr.t("Replacecard")}</button> */}
                        //             {/* <div className="lineC" >{tr.t("Cost")}</div> */}
                        //         </div>
                        //     </div>
                        // </div> : null
                    }
                </div>}
            </div>
        );
    }
}

export default CardPnl;



// WEBPACK FOOTER //
// ./src/assets/components/panel/CardPnl.js